import React from "react";
import {Checkout} from "depoto-core";
import {formatPrice} from "../utils";
import {useCore} from "../hooks";
import './CheckoutTile.css'

type Props = {
  checkout: Checkout
  isShowingClosingData?: boolean
  isOpen?: boolean
}
export const CheckoutTileDetail: React.FC<Props> = ({ checkout, isShowingClosingData, isOpen }) => {
  const { currency, core } = useCore()
  const hasRoleShowProfit = core.services.user.hasOneOfTheRoles(['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_CHECKOUT_SHOW_PROFIT'])
  return (
    <>
      {isShowingClosingData ? (
        <div className="p-4 text-xs">
          {/*<div className="flex flex-row justify-between">*/}
          {/*  <div className="font-bold">Celková tržba pokladny</div>*/}
          {/*  TODO how to calc?*/}
          {/*  <div className="text-right text-primary font-semibold">{formatPrice(checkout.currentClosing?.amountRealClosed || 0)}</div>*/}
          {/*</div>*/}
          <div className="flex flex-row justify-between">
            <div className="font-bold">Stav od otevření pokladny</div>
            <div className="text-right text-primary font-semibold">{formatPrice((checkout.amount) || 0, currency.id)}</div>
          </div>
          <div className="flex flex-row justify-between">
            <div className="font-bold">Otevřeno uživatelem</div>
            <div>{checkout.currentClosing?.userOpen?.email}</div>
          </div>
        </div>
      ) : (
        <div className="p-4 text-xs">
          {isOpen ? (
            <>
              <div className="flex flex-row justify-between">
                <div className="font-bold">Celková tržba</div>
                <div className="text-right text-primary font-semibold">{formatPrice(checkout.currentClosing?.amountRealClosed || 0, currency.id)}</div>
              </div>
              {hasRoleShowProfit ? (
                <div className="flex flex-row justify-between">
                  <div className="font-bold">Zisk</div>
                  <div className="text-right text-primary font-semibold">{formatPrice(checkout?.currentClosing?.profit || 0, currency.id)}</div>
                </div>
              ) : null}
            </>
          ) : (
            <div className="flex flex-row justify-between">
              <div className="font-bold">Hotovost</div>
              <div className="text-right text-primary font-semibold">{formatPrice(checkout.amount || 0, currency.id)}</div>
            </div>
          )}


          {/*<div className="flex flex-row justify-between">*/}
          {/*  <div className="font-bold">Zisk od uzavření pokladny</div>*/}
          {/*  <div className="text-right text-primary font-semibold">{formatPrice((checkout.currentClosing?.amountRealClosed - checkout.currentClosing?.amountRealOpen) || 0, currency.id)}</div>*/}
          {/*</div>*/}
          {/*<div className="flex flex-row justify-between">*/}
          {/*  <div className="font-bold">Zavřeno uživatelem</div>*/}
          {/*  <div>{checkout.currentClosing?.userClosed?.email}</div>*/}
          {/*</div>*/}
        </div>
      )}
    </>
  )
}
